"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Pill = ({
  prefix,
  iconOnly,
  label,
  selected,
  disabled,
  small,
  thumbnail,
  ssrIcon,
  iconPosition,
  thumbnailAlt,
  className,
  onClick,
  ...other
}) => {
  const baseClass = `${prefix}pill`;
  const pillClasses = (0, _classnames.default)(`${baseClass}`, small && `${baseClass}--small`, iconOnly && ssrIcon && !thumbnail && `${baseClass}--icon`, !iconOnly && ssrIcon && !thumbnail && `${prefix}${iconPosition}-icon`, thumbnail && `${baseClass}--thumbnail`, selected && !disabled && `${baseClass}--active`, className);
  return _react.default.createElement("button", _extends({
    className: pillClasses,
    disabled: disabled,
    "aria-pressed": selected ? 'true' : 'false',
    onClick: onClick
  }, other), thumbnail && _react.default.createElement("img", {
    className: `${baseClass}__thumbnail`,
    src: thumbnail,
    alt: thumbnailAlt
  }), ssrIcon && !thumbnail && _react.default.createElement(_ssrIcon.default, {
    prefix: prefix,
    paths: ssrIcon,
    className: `${baseClass}__icon`
  }), label && _react.default.createElement("span", {
    className: `${baseClass}__label`
  }, label));
};

Pill.defaultProps = {
  prefix: '',
  iconPosition: 'leading'
};
var _default = Pill;
exports.default = _default;